import { CURRENT_COUNTRY } from "utils/constants";

export const getLanguageCode = (language) => {
	const countryCode = CURRENT_COUNTRY === "ch" ? "de" : CURRENT_COUNTRY;
	const langCode = language === "default" ? countryCode : language;
	return langCode;
};